import { EAppActions } from "./types.js";
export const appReducer = (prevState, action) => {
    switch (action.type) {
        /* -------------------------------------------------------------------------------------------------
         * App
         * -----------------------------------------------------------------------------------------------*/
        case EAppActions.CONNECT_WALLET_OPEN:
            return {
                ...prevState,
                walletConnectOpen: action.payload.walletConnectOpen,
            };
        case EAppActions.SET_WRONG_NETWORK_OPEN:
            return {
                ...prevState,
                wrongNetworkOpen: action.payload.wrongNetworkOpen,
            };
        default:
            throw new Error("No action was found!");
    }
};
//# sourceMappingURL=reducer.js.map